import { gql, useQuery } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedUseQuery } from '@/lib/apollo/types'

const getSubjectBotLinkQuery = gql`
  query ($customerId: String!, $applicationId: String!, $subjectId: String!) {
    getSubjectBotLink(
      customerId: $customerId
      applicationId: $applicationId
      subjectId: $subjectId
    )
  }
`

export type GetSubjectBotLinkData = {
  getSubjectBotLink: string | null
}

export type QueryVars = {
  customerId: string
  applicationId: string
  subjectId: string
}

export const useGetSubjectBotLinkQuery: WrappedUseQuery<
  GetSubjectBotLinkData,
  QueryVars
> = options =>
  useQuery<GetSubjectBotLinkData, QueryVars>(getSubjectBotLinkQuery, {
    ...options,
    client: agentClient,
  })
